<template>
  <div class="boxall">
    <div class="title">六统一</div>
    <div class="boxnav">
      <div class="content">
        <ul class="details">
          <li class="left">
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一养殖规程</div>
            </div>

            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一质量追溯</div>
            </div>

            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一品牌授权</div>
            </div>
          </li>

          <li class="right">
            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一加工工艺</div>
            </div>

            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一包装标识</div>
            </div>

            <div class="item-box">
              <div class="item-icon">
                <img src="../assets/images/brand_.png" alt="icon" />
              </div>
              <div class="item-info">统一标准</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandManage'
}
</script>

<style scoped>
.content {
  height: 100%;
}

.content > ul {
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.left,
.right {
  flex: 0 0 50%;
  height: 100%;
  display: flex;
  flex-direction: column; /* 纵向排列 3 个框 */
  gap: 16px; /* 上下三行之间的间距 */
  padding: 0 5px;
  box-sizing: border-box;
}

.details > li > div {
  flex: 1; /* 三个框平均分配列高度 */
  width: 100%;
  border-radius: 6px;
  border: 1px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 16px rgba(146, 209, 230, 0.4), inset 0 0 60px rgb(0 191 255 / 35%),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
}

li > div.item-box {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
  padding: 0 2px;
  box-sizing: border-box;
}

.item-icon {
  height: 40px;
  width: 40px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  margin-left: 16px;
}

.item-icon img {
  width: 24px;
  height: 24px;
}

/* 右侧文字区域 — 垂直居中 */
.item-info {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  color: #05e2e4;
}
</style>
